import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTelegram } from '../context/TelegramContext';

const DeepLinkHandler = () => {
  const navigate = useNavigate();
  const { webApp } = useTelegram();
  const hasNavigated = useRef(false);

  useEffect(() => {
    // Check if we have access to the Telegram Web App API
    if (!webApp) return;

    // Get the startapp parameter from the Telegram Web App API
    const startApp = webApp.initDataUnsafe?.start_param;

    // If there's no startapp parameter, do nothing
    if (!startApp) return;

    // Only navigate if we haven't already done so
    if (hasNavigated.current) return;

    // Check if the startapp parameter is in the format "ad_X"
    if (startApp.startsWith('ad_')) {
      // Extract the ad ID from the startapp parameter
      const adId = startApp.substring(3); // Remove "ad_" prefix

      // Set the flag to prevent future navigations
      hasNavigated.current = true;

      // Navigate to the ad details page
      navigate(`/ad/${adId}`, { replace: true });

      console.log(`Deep link detected: navigating to ad ${adId}`);
      window.history.replaceState(null, '', process.env.REACT_APP_BASE_PATH);
      // window.location.href = process.env.REACT_APP_BASE_PATH;
    }
  }, [webApp, navigate]);

  // This component doesn't render anything
  return null;
};

export default DeepLinkHandler;
